/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react'

function Music() {
  return (
    <div className="flex flex-col justify-center items-center w-full h-full">
    <iframe
src="https://musify-vibes.vercel.app/"
style={{ border: "0px #ffffff none" }}
name="myiFrame"

height="100%"
width="100%"
/>
    </div>
  )
}

export default Music